import {firstValueFrom} from "rxjs";
import {computed, effect, inject, Injectable} from '@angular/core';
import {RemoveWalletUseCase} from "@features/wallet/application/use-cases/remove-wallet.use-case";
import {RouteVisibilityPort} from "@features/wallet/application/ports/route-visibility.port";
import {WalletStatus, WalletStore} from "@features/wallet/application/store/wallet.store";
import {WalletWidgetMapper} from "@features/wallet/application/mappers/wallet-widget.mapper";
import {PAYMENT_FEEDBACK} from "@features/payment/domain/ports/ui/feedback.port";

@Injectable({providedIn: 'root'})
export class WalletWidgetFacade {
  private readonly store = inject(WalletStore);
  private readonly mapper = inject(WalletWidgetMapper);
  private readonly notifier = inject(PAYMENT_FEEDBACK);
  private readonly removeWallet = inject(RemoveWalletUseCase);
  private readonly routeVisibility = inject(RouteVisibilityPort);

  readonly walletId = computed(
    () => this.store.state().wallet?.id
  );

  readonly hasReachedLimit = computed(
    () => this.store.state().hasReachedLimit)
  ;

  readonly viewModel = computed(
    () => this.mapper.toVM(this.store.state().wallet)
  );

  readonly isWalletActive = computed(
    () => this.store.state().status === WalletStatus.ACTIVE || this.store.state().status === WalletStatus.RELOAD
  );

  readonly isVisible = computed(() => {
    return this.isWalletActive() && this.routeVisibility.isOnProductsRoute();
  });

  private readonly notifyOnLimitReached = effect(() => {
    if (this.hasReachedLimit()) {
      this.notifier.showError('fv_snackbar.wallet.not_enough_money_msg');
    }
  });

  remove(): void {
    void firstValueFrom(this.removeWallet.execute());
  }
}
